import { render, staticRenderFns } from "./testCase.vue?vue&type=template&id=28f501f9"
import script from "./testCase.vue?vue&type=script&lang=js"
export * from "./testCase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28f501f9')) {
      api.createRecord('28f501f9', component.options)
    } else {
      api.reload('28f501f9', component.options)
    }
    module.hot.accept("./testCase.vue?vue&type=template&id=28f501f9", function () {
      api.rerender('28f501f9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/research/question-manage/testCase.vue"
export default component.exports